"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UIPage = require("./../UIPage.js"),
    regionalLayout = require("./../../layouts/RegionalLayout"),
    template = require("./RegionalHome.html"),
    api = require("./../../../network/api.js"),
    loader = require("./../../components/Loading/loading.js"),
    Notify = require("./../../components/Notification/notifications.js"),
    $ = "undefined" != typeof window ? window.jQuery : "undefined" != typeof global ? global.jQuery : null,
    ondemanreports = require("../../components/Reports/Reports.js");
var RegionalHome = function (_UIPage) {
  _inherits(RegionalHome, _UIPage);

  function RegionalHome() {
    _classCallCheck(this, RegionalHome);

    return _possibleConstructorReturn(this, (RegionalHome.__proto__ || Object.getPrototypeOf(RegionalHome)).call(this, template, { title: "Regional Home" }));
  }

  _createClass(RegionalHome, [{
    key: "onComponentReadyAsync",
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e) {
        var o;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                document.querySelector("omnibar-shell").pageId = "/regionalhome";
                document.querySelector("omnibar-page-header").pageTitle = "On Demand Reports";
                window.Omnibar.GetPropertyLevelHelpLink(window.location);

                if (!(void 0 != this.data.src)) {
                  _context.next = 9;
                  break;
                }

                _context.next = 6;
                return new ondemanreports(100, 152, this.data.src, this.data.bookId);

              case 6:
                _context.t0 = _context.sent;
                _context.next = 12;
                break;

              case 9:
                _context.next = 11;
                return new ondemanreports(100, 152, "mp");

              case 11:
                _context.t0 = _context.sent;

              case 12:
                _context.t1 = $(this.refs.pnlReportSelector);

                (o = _context.t0).attach(_context.t1);

                o.renderAsync();

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onComponentReadyAsync(_x) {
        return _ref.apply(this, arguments);
      }

      return onComponentReadyAsync;
    }()
  }]);

  return RegionalHome;
}(UIPage);

module.exports = RegionalHome;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlJlZ2lvbmFsSG9tZS5qcyJdLCJuYW1lcyI6WyJVSVBhZ2UiLCJyZXF1aXJlIiwicmVnaW9uYWxMYXlvdXQiLCJ0ZW1wbGF0ZSIsImFwaSIsImxvYWRlciIsIk5vdGlmeSIsIiQiLCJ3aW5kb3ciLCJnbG9iYWwiLCJvbmRlbWFucmVwb3J0cyIsIlJlZ2lvbmFsSG9tZSIsIltvYmplY3QgT2JqZWN0XSIsInRpdGxlIiwiZGF0YSIsImRvY3VtZW50IiwicXVlcnlTZWxlY3RvciIsInBhZ2VJZCIsInBhZ2VUaXRsZSIsIk9tbmliYXIiLCJHZXRQcm9wZXJ0eUxldmVsSGVscExpbmsiLCJsb2NhdGlvbiIsInRoaXMiLCJzcmMiLCJ1bmRlZmluZWQiLCJyZXBvcnRMaXN0IiwiYm9va0lkIiwiYXR0YWNoIiwicmVmcyIsInBubFJlcG9ydFNlbGVjdG9yIiwicmVuZGVyQXN5bmMiLCJtb2R1bGUiLCJleHBvcnRzIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7QUFBQyxJQUFNQSxTQUFTQyxRQUFRLGdCQUFSQSxDQUFmO0FBQUEsSUFDR0MsaUJBQWlCRCxRQUFRLGdDQUFSQSxDQURwQjtBQUFBLElBRUdFLFdBQVdGLFFBQVEscUJBQVJBLENBRmQ7QUFBQSxJQUdHRyxNQUFNSCxRQUFRLDJCQUFSQSxDQUhUO0FBQUEsSUFJR0ksU0FBU0osUUFBUSx1Q0FBUkEsQ0FKWjtBQUFBLElBS0dLLFNBQVNMLFFBQVEsa0RBQVJBLENBTFo7QUFBQSxJQU1HTSxJQUF1QixlQUFBLE9BQVhDLE1BQVcsR0FBY0EsT0FBZSxNQUE3QixHQUFtRCxlQUFBLE9BQVhDLE1BQVcsR0FBY0EsT0FBZSxNQUE3QixHQUFpQyxJQU45RztBQUFBLElBT0dDLGlCQUFpQlQsUUFBUSxxQ0FBUkEsQ0FQcEI7SUFRS1UsWTs7O0FBQ0ZDLDBCQUFBQTtBQUFBQTs7QUFBQUEsdUhBQ1VULFFBRFZTLEVBQ1VULEVBQVlVLE9BQU8sZUFBbkJWLEVBRFZTO0FBSUFBOzs7OzswRkFBNEJFLEM7Ozs7OztBQUN4QkMseUJBQVNDLGFBQVRELENBQXVCLGVBQXZCQSxFQUF3Q0UsTUFBeENGLEdBQWlELGU7QUFDakRBLHlCQUFTQyxhQUFURCxDQUF1QixxQkFBdkJBLEVBQThDRyxTQUE5Q0gsR0FBMEQsbUI7QUFDMURQLHVCQUFPVyxPQUFQWCxDQUFlWSx3QkFBZlosQ0FBd0NBLE9BQU9hLFFBQS9DYixDOztzQkFNSWlCLEtBRmlCRCxDQUVqQkMsSUFGQUgsS0FBS1IsSUFBTFEsQ0FBVUMsRzs7Ozs7O3VCQUVTLElBQUliLGNBQUosQ0FBbUIsR0FBbkIsRUFBd0IsR0FBeEIsRUFBNkJZLEtBQUtSLElBQUxRLENBQVVDLEdBQXZDLEVBQTRDRCxLQUFLUixJQUFMUSxDQUFVSSxNQUF0RCxDOzs7Ozs7Ozs7dUJBR0EsSUFBSWhCLGNBQUosQ0FBbUIsR0FBbkIsRUFBd0IsR0FBeEIsRUFBNkIsSUFBN0IsQzs7Ozs7OzhCQUdMSCxFQUFFZSxLQUFLTSxJQUFMTixDQUFVTyxpQkFBWnRCLEM7O2lCQU5ka0IsQyxnQkFNT0UsTTs7QUFDWEYsa0JBQVdLLFdBQVhMLEU7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7RUFyQm1CekIsTTs7QUF5QjNCK0IsT0FBT0MsT0FBUEQsR0FBaUJwQixZQUFqQm9CIn0=